import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { userPropTypes } from '../../../prop-types'
import { AVATARS } from '../../../constants'
import Circle from '../../common/Circle'
import Row from '../../common/Row'
import Spacer from '../../common/Spacer'
import Text from '../../common/Text'
import Icon from '../../common/Icon'
import ImageBackground from '../../common/ImageBackground'
import TreesCounter from '../TreesCounter'

const ROW_HEIGHT = 70
const CIRCLE_SIZE = 50
const MASK_SIZE = 30
const DELTA = 1.5
const BREAKPOINT = 15

const RankingRow = ({
    user,
    position,
    isMe,
    title,
    ...rest
}) => {

    // Highlight in case current user is included in this row
    const color = isMe ? 'lightBlue1' : 'dark'

    const avatar = get(user, 'profile.avatar', AVATARS[0])

    return (
        <Row
            height={ROW_HEIGHT}
            alignItems="center"
            justifyContent="space-between"
            bgColor="white"
            {...rest}
        >
            <Text size="XXL" color={color} style={{ minWidth: 25 }}>
                {position}
            </Text>
            <Spacer row size="XS" />
            <Row
                alignItems="center"
                justifyContent="flex-start"
                style={{ flex: 1 }}
            >
                {isMe ? (
                    <ImageBackground
                        imageName="laurels@2x.png"
                        width={DELTA * MASK_SIZE}
                        height={DELTA * MASK_SIZE}
                        justifyContent="center"
                    >
                        <Icon
                            iconName={`${avatar}@2x.png`}
                            alt="mask"
                            height={MASK_SIZE}
                            width={MASK_SIZE}
                            alignSelf="center"
                        />
                        <Spacer size="XXXS" />
                    </ImageBackground>
                ) : (
                    <Circle
                        radius={CIRCLE_SIZE}
                        borderColor="white"
                        alignItems="center"
                        justifyContent="center"
                        bgColor="lightGrey3"
                        style={{
                            alignSelf: 'center',
                        }}
                    >
                        <Icon
                            iconName={`${avatar}@2x.png`}
                            alt="mask"
                            height={MASK_SIZE}
                            width={MASK_SIZE}
                            alignSelf="center"
                        />
                    </Circle>
                )}
                <Spacer row size="XS" />
                <Text
                    size="S"
                    color={color}
                    semibold
                    center
                >
                    {title.length > BREAKPOINT ? `${title.slice(0, BREAKPOINT - 1)}...` : title}
                </Text>
            </Row>
            <Spacer row size="XXS" />
            <TreesCounter trees={user.trees} />
        </Row>
    )
}

RankingRow.propTypes = {
    user: userPropTypes.isRequired,
    position: PropTypes.number.isRequired,
    isMe: PropTypes.bool,
    title: PropTypes.string,
}

RankingRow.defaultProps = {
    isMe: false,
    title: '',
}

export default RankingRow
